<template>
  <div>
    <!-- Alert: No item found -->
    <b-breadcrumb class="breadcrumb-slash mb-1">
      <b-breadcrumb-item :to="{ name: 'product-list' }">
        ข้อมูลสินค้า
      </b-breadcrumb-item>
      <b-breadcrumb-item active>
        ดูข้อมูล
      </b-breadcrumb-item>
    </b-breadcrumb>
    <template>
      <!-- First Row -->
      <b-row>
        <b-col cols="12">
          <b-card>
            <b-row>
              <b-col cols="12" class="d-flex justify-content-end mb-2">
                <b-button
                  v-b-modal.modal-product-status
                  variant="outline-primary"
                  class="mr-2"
                >
                  แก้ไข
                </b-button>
                <!-- <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                >
                  Delete
                </b-button> -->
              </b-col>
            </b-row>
            <swiper-responsive :swiper-data="swiperData" />
          </b-card>
        </b-col>
        <!-- <b-col cols="12" md="5" xl="3" lg="4">
          <user-view-user-plan-card />
        </b-col> -->
      </b-row>

      <b-row v-if="productData">
        <b-col cols="12" lg="6">
          <b-card>
            <product-view-information :product="productData" />
          </b-card>

          <!-- <user-view-user-timeline-card /> -->
        </b-col>
        <b-col cols="12" lg="6">
          <b-card>
            <product-view-detail :product="productData" />
          </b-card>

          <!-- <user-view-user-permissions-card /> -->
        </b-col>
      </b-row>
    </template>
    <b-modal
      id="modal-product-status"
      centered
      title="สถานะการใช้งาน"
      ok-only
      ok-title="บันทึก"
      @ok="handlerDelete"
      ref="modal-product"
    >
      <b-form-group>
        <v-select
          v-model="selected"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          label="title"
          :options="option"
        />
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import store from "@/store";
import router from "@/router";
import { ref, onUnmounted } from "@vue/composition-api";
import {
  BRow,
  BCol,
  BAlert,
  BLink,
  BCard,
  BButton,
  BFormGroup,
  BBreadcrumb,
  BBreadcrumbItem,
} from "bootstrap-vue";
import InvoiceList from "@/views/apps/invoice/invoice-list/InvoiceList.vue";
import userStoreModule from "../productStoreModule";
import SwiperResponsive from "./SwiperResponsive.vue";
import ProductViewInformation from "./ProductViewInformation.vue";
import Ripple from "vue-ripple-directive";
import ProductViewDetail from "./ProductViewDetail.vue";
import vSelect from "vue-select";

export default {
  components: {
    BRow,
    BCol,
    BAlert,
    BLink,
    SwiperResponsive,
    // Local Components
    InvoiceList,
    BCard,
    BButton,
    ProductViewInformation,
    ProductViewDetail,
    BFormGroup,
    vSelect,
    BBreadcrumb,
    BBreadcrumbItem,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      selected: { title: "ใช้งาน" },

      option: [{ title: "ใช้งาน" }, { title: "ไม่ใช้งาน" }],
    };
  },
  mounted() {
    if (router.currentRoute.params.isEdit == true) {
      this.$refs["modal-product"].show();
    }
  },
  setup() {
    const productData = ref(null);
    const swiperData = ref([]);
    const USER_APP_STORE_MODULE_NAME = "product";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    store
      .dispatch("product/fetchProduct", { id: router.currentRoute.params.id })
      .then((response) => {
        console.log("paramsId", response);
        productData.value = response.data.data;

        response.data.data.productImages.forEach((imgProduct) => {
          swiperData.value.push({
            img: imgProduct.mediaUrl,
          });
        });

        console.log("paramsId", this.swiperData);
      })
      .catch((error) => {
        if (error.response.status === 404) {
          productData.value = undefined;
        }
      });

    return {
      productData,
      swiperData,
    };
  },
  methods: {
    handlerDelete() {
      console.log("", this.productData);
      if (this.selected.title == "ไม่ใช้งาน") {
        store
          .dispatch("product/deleteProduct", {
            id: this.productData.id,
            status: false,
          })
          .then((response) => {
            console.log("data", response);
          })
          .catch((error) => {
            console.log("err", error);
          });
      } else {
        store
          .dispatch("product/deleteProduct", {
            id: this.productData.id,
            status: true,
          })
          .then((response) => {
            console.log("data", response);
          })
          .catch((error) => {
            console.log("err", error);
          });
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/swiper.scss";
</style>
